module.exports = {
	"ha": "fha",
	"id": 5.5,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2019 Q1–2020 Q4",
		"lastYear": "2020",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by Age Category and MSM Status, Year Ending 2020 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "36"
						},
						"color": "#043f61"
					},
					{
						"y": 88.88888888888889,
						"dataLabels": {
							"enabled": false,
							"format": "32"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.11111111111111,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#0d4440"
					},
					{
						"y": 77.77777777777779,
						"dataLabels": {
							"enabled": false,
							"format": "28"
						},
						"color": "#09472e"
					},
					{
						"y": 58.333333333333336,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "132"
						},
						"color": "#043f61"
					},
					{
						"y": 84.84848484848484,
						"dataLabels": {
							"enabled": false,
							"format": "112"
						},
						"color": "#0c4250"
					},
					{
						"y": 81.81818181818183,
						"dataLabels": {
							"enabled": false,
							"format": "108"
						},
						"color": "#0d4440"
					},
					{
						"y": 76.51515151515152,
						"dataLabels": {
							"enabled": false,
							"format": "101"
						},
						"color": "#09472e"
					},
					{
						"y": 54.54545454545454,
						"dataLabels": {
							"enabled": false,
							"format": "72"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "119"
						},
						"color": "#043f61"
					},
					{
						"y": 96.63865546218487,
						"dataLabels": {
							"enabled": false,
							"format": "115"
						},
						"color": "#0c4250"
					},
					{
						"y": 89.07563025210085,
						"dataLabels": {
							"enabled": false,
							"format": "106"
						},
						"color": "#0d4440"
					},
					{
						"y": 84.03361344537815,
						"dataLabels": {
							"enabled": false,
							"format": "100"
						},
						"color": "#09472e"
					},
					{
						"y": 67.22689075630252,
						"dataLabels": {
							"enabled": false,
							"format": "80"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "486"
						},
						"color": "#043f61"
					},
					{
						"y": 93.4156378600823,
						"dataLabels": {
							"enabled": false,
							"format": "454"
						},
						"color": "#0c4250"
					},
					{
						"y": 89.7119341563786,
						"dataLabels": {
							"enabled": false,
							"format": "436"
						},
						"color": "#0d4440"
					},
					{
						"y": 86.83127572016461,
						"dataLabels": {
							"enabled": false,
							"format": "422"
						},
						"color": "#09472e"
					},
					{
						"y": 67.48971193415639,
						"dataLabels": {
							"enabled": false,
							"format": "328"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "22"
						},
						"color": "#043f61"
					},
					{
						"y": 72.72727272727273,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#0c4250"
					},
					{
						"y": 72.72727272727273,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#0d4440"
					},
					{
						"y": 68.18181818181817,
						"dataLabels": {
							"enabled": false,
							"format": "15"
						},
						"color": "#09472e"
					},
					{
						"y": 45.45454545454545,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.34146341463415,
						"dataLabels": {
							"enabled": false,
							"format": "79"
						},
						"color": "#043f61"
					},
					{
						"y": 92.6829268292683,
						"dataLabels": {
							"enabled": false,
							"format": "76"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.14634146341463,
						"dataLabels": {
							"enabled": false,
							"format": "69"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.95121951219512,
						"dataLabels": {
							"enabled": false,
							"format": "59"
						},
						"color": "#09472e"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "41"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.61751152073732,
						"dataLabels": {
							"enabled": false,
							"format": "214"
						},
						"color": "#043f61"
					},
					{
						"y": 87.09677419354838,
						"dataLabels": {
							"enabled": false,
							"format": "189"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.48847926267281,
						"dataLabels": {
							"enabled": false,
							"format": "179"
						},
						"color": "#0d4440"
					},
					{
						"y": 74.19354838709677,
						"dataLabels": {
							"enabled": false,
							"format": "161"
						},
						"color": "#09472e"
					},
					{
						"y": 49.30875576036866,
						"dataLabels": {
							"enabled": false,
							"format": "107"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "484"
						},
						"color": "#043f61"
					},
					{
						"y": 89.6694214876033,
						"dataLabels": {
							"enabled": false,
							"format": "434"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.53719008264463,
						"dataLabels": {
							"enabled": false,
							"format": "414"
						},
						"color": "#0d4440"
					},
					{
						"y": 79.75206611570248,
						"dataLabels": {
							"enabled": false,
							"format": "386"
						},
						"color": "#09472e"
					},
					{
						"y": 57.85123966942148,
						"dataLabels": {
							"enabled": false,
							"format": "280"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 68.75,
						"dataLabels": {
							"enabled": false,
							"format": "44"
						},
						"color": "#043f61"
					},
					{
						"y": 60.9375,
						"dataLabels": {
							"enabled": false,
							"format": "39"
						},
						"color": "#0c4250"
					},
					{
						"y": 53.125,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#0d4440"
					},
					{
						"y": 48.4375,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#09472e"
					},
					{
						"y": 20.3125,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98,
						"dataLabels": {
							"enabled": false,
							"format": "98"
						},
						"color": "#043f61"
					},
					{
						"y": 84,
						"dataLabels": {
							"enabled": false,
							"format": "84"
						},
						"color": "#0c4250"
					},
					{
						"y": 79,
						"dataLabels": {
							"enabled": false,
							"format": "79"
						},
						"color": "#0d4440"
					},
					{
						"y": 73,
						"dataLabels": {
							"enabled": false,
							"format": "73"
						},
						"color": "#09472e"
					},
					{
						"y": 51,
						"dataLabels": {
							"enabled": false,
							"format": "51"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.49238578680203,
						"dataLabels": {
							"enabled": false,
							"format": "196"
						},
						"color": "#043f61"
					},
					{
						"y": 78.68020304568529,
						"dataLabels": {
							"enabled": false,
							"format": "155"
						},
						"color": "#0c4250"
					},
					{
						"y": 75.1269035532995,
						"dataLabels": {
							"enabled": false,
							"format": "148"
						},
						"color": "#0d4440"
					},
					{
						"y": 69.54314720812182,
						"dataLabels": {
							"enabled": false,
							"format": "137"
						},
						"color": "#09472e"
					},
					{
						"y": 48.73096446700508,
						"dataLabels": {
							"enabled": false,
							"format": "96"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.83720930232558,
						"dataLabels": {
							"enabled": false,
							"format": "425"
						},
						"color": "#043f61"
					},
					{
						"y": 79.06976744186046,
						"dataLabels": {
							"enabled": false,
							"format": "340"
						},
						"color": "#0c4250"
					},
					{
						"y": 74.65116279069768,
						"dataLabels": {
							"enabled": false,
							"format": "321"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.16279069767441,
						"dataLabels": {
							"enabled": false,
							"format": "306"
						},
						"color": "#09472e"
					},
					{
						"y": 54.65116279069767,
						"dataLabels": {
							"enabled": false,
							"format": "235"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.125,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.677419354838712,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.151515151515149,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.481481481481477,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.712871287128717,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.361344537815125,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.826086956521738,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.660377358490565,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.584362139917699,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.964757709251099,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.2110091743119296,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.274881516587676,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.27272727272727,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.658536585365857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.797468354430378,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.210526315789469,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.492753623188403,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.508474576271183,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.382488479262678,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.682242990654201,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.291005291005291,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.05586592178771,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.54037267080745,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.330578512396693,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.608294930875578,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.763285024154586,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.461139896373055,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -31.25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.363636363636365,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.82051282051282,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.823529411764708,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -58.06451612903225,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.0000000000000018,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.952380952380953,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.594936708860756,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.136986301369863,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.5076142131979711,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.918367346938773,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.516129032258065,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.432432432432434,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -29.92700729927007,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.1627906976744207,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.588235294117649,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.672897196261683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.202614379084963,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=36"
			},
			{
				"x": 9,
				"text": "30-39<br>n=132"
			},
			{
				"x": 15,
				"text": "40-49<br>n=119"
			},
			{
				"x": 21,
				"text": ">=50<br>n=486"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=22"
			},
			{
				"x": 34,
				"text": "30-39<br>n=82"
			},
			{
				"x": 40,
				"text": "40-49<br>n=217"
			},
			{
				"x": 46,
				"text": ">=50<br>n=484"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=64"
			},
			{
				"x": 59,
				"text": "30-39<br>n=100"
			},
			{
				"x": 65,
				"text": "40-49<br>n=197"
			},
			{
				"x": 71,
				"text": ">=50<br>n=430"
			}
		],
		"dataTable": {
			"MSM:<30": [
				36,
				36,
				32,
				31,
				28,
				21
			],
			"MSM:30-39": [
				132,
				132,
				112,
				108,
				101,
				72
			],
			"MSM:40-49": [
				119,
				119,
				115,
				106,
				100,
				80
			],
			"MSM:>=50": [
				486,
				486,
				454,
				436,
				422,
				328
			],
			"Non-MSM:<30": [
				22,
				22,
				16,
				16,
				15,
				10
			],
			"Non-MSM:30-39": [
				82,
				79,
				76,
				69,
				59,
				41
			],
			"Non-MSM:40-49": [
				217,
				214,
				189,
				179,
				161,
				107
			],
			"Non-MSM:>=50": [
				484,
				484,
				434,
				414,
				386,
				280
			],
			"Unknown:<30": [
				64,
				44,
				39,
				34,
				31,
				13
			],
			"Unknown:30-39": [
				100,
				98,
				84,
				79,
				73,
				51
			],
			"Unknown:40-49": [
				197,
				196,
				155,
				148,
				137,
				96
			],
			"Unknown:>=50": [
				430,
				425,
				340,
				321,
				306,
				235
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_5_5.json
// module id = 204
// module chunks = 0